var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 77,
    viewBox: "0 0 626 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 77V61.75H30.5V77H0ZM30.5 61.75V46.5H45.75V61.75H30.5ZM15.25 46.5V31.25H30.5V46.5H15.25ZM0 31.25V16H15.25V31.25H0ZM15.25 16V0.75H45.75V16H15.25ZM91.5 77V46.5H106.75V77H91.5ZM61 77V0.75H76.25V31.25H91.5V46.5H76.25V77H61ZM91.5 31.25V0.75H106.75V31.25H91.5ZM122 77V61.75H137.25V16H122V0.75H167.75V16H152.5V61.75H167.75V77H122ZM183 77V0.75H198.25V61.75H228.75V77H183ZM244 77V0.75H259.25V61.75H289.75V77H244Z",
    fill: "#6738ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M305 61.75V16H320.25V61.75H305ZM320.25 77V61.75H335.5V46.5H350.75V16H366V61.75H381.25V77H320.25ZM320.25 16V0.75H350.75V16H320.25ZM396.5 77V0.75H411.75V61.75H427V0.75H442.25V77H396.5ZM457.5 77V0.75H503.25V16H472.75V31.25H488V46.5H472.75V61.75H503.25V77H457.5ZM518.5 77V61.75H549V77H518.5ZM549 61.75V46.5H564.25V61.75H549ZM533.75 46.5V31.25H549V46.5H533.75ZM518.5 31.25V16H533.75V31.25H518.5ZM533.75 16V0.75H564.25V16H533.75ZM594.75 77V16H579.5V0.75H625.25V16H610V77H594.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.1a6a7547df089994b1d46a0366fab89c.svg";
export { ForwardRef as ReactComponent };